import { render } from "./IqraSchedulesManagement.vue?vue&type=template&id=5fad949c"
import script from "./IqraSchedulesManagement.vue?vue&type=script&lang=js"
export * from "./IqraSchedulesManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__